
import React, { FC } from 'react';
import styled from 'styled-components';

const SvgWrapper = styled.div`
  svg {
    transform: rotate(180deg);
  }
`;

export const ArrowSmallIcon: FC<{ fill?: string; rotate?: number }> = ({ fill, rotate = 0 }) => (
    <svg
        width="10"
        height="5"
        viewBox="0 0 10 5"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ transform: `rotate(${rotate}deg)`, transition: 'transform 0.2s' }}
    >
        <path d="M1.30988 4.8743L5 1.53612L8.69012 4.8743C8.87539 5.0419 9.17578 5.0419 9.36105 4.8743C9.54632 4.70669 9.54632 4.43495 9.36104 4.26735L5.33546 0.625701C5.15019 0.458099 4.84981 0.458099 4.66454 0.625701L0.638956 4.26735C0.453683 4.43495 0.453682 4.70669 0.638952 4.87429C0.824224 5.0419 1.12461 5.0419 1.30988 4.8743Z" fill={fill || '#545453'} />
    </svg>
);

export default ArrowSmallIcon;


import React, { FC } from 'react';
import styled from 'styled-components';

const SvgWrapper = styled.div`
  svg {
    transform: rotate(180deg);
  }
`;

export const ArrowSmallIcon: FC<{ fill?: string; rotate?: number }> = ({ fill, rotate = 0 }) => (
    <svg
        width="10"
        height="5"
        viewBox="0 0 10 5"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ transform: `rotate(${rotate}deg)`, transition: 'transform 0.2s' }}
    >
        <path d="M1.30988 4.8743L5 1.53612L8.69012 4.8743C8.87539 5.0419 9.17578 5.0419 9.36105 4.8743C9.54632 4.70669 9.54632 4.43495 9.36104 4.26735L5.33546 0.625701C5.15019 0.458099 4.84981 0.458099 4.66454 0.625701L0.638956 4.26735C0.453683 4.43495 0.453682 4.70669 0.638952 4.87429C0.824224 5.0419 1.12461 5.0419 1.30988 4.8743Z" fill={fill || '#545453'} />
    </svg>
);

export default ArrowSmallIcon;

